import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ASSETS = {
  heroFleet: "/images/fleet.png",
  fleet: "/images/fleet.png",
  trust: "/images/ht-i.png",
  alps:
    "https://images.pexels.com/photos/39006580/pexels-photo-39006580.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CONTACT = {
  phone: "+41 79 470 64 23",
  phoneHref: "tel:+41794706423",
  email: "info@skyworthcars.ch",
  address: "Bühlmattweg 20, 5615 Fahrwangen, Schweiz",
};
